export const CustomerInfo = () => {

    return (
        <div>
            Customer Info Page
        </div>
    )
}